module.exports = __webpack_public_path__ + "img/indiba-wechat.b271442b.jpeg";